import React from 'react'
import styled from 'styled-components'
import { AboBadge } from '../AboBadge'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
export type ArticleTeaserProps = {
  notPremium?: boolean
  titleHead?: string
  title: string
  lead?: string
  children?: JSX.Element | JSX.Element[]
  link?: string
  isMobile?: boolean
}
export const ArticleTeaser = ({
  notPremium = false,
  title,
  lead,
  titleHead,
  link,
  isMobile
}: ArticleTeaserProps) => {
  let domain = parseHostname()
  let url = 'https://' + domain.projectDomain + '/' + link
  return (
    <ArticleTeaserRoot href={url} target='_blank'>
      <H3Wrapper>
        {titleHead && (
          <TitleHead>
            {!notPremium && <AboBadge />}
            {titleHead}
          </TitleHead>
        )}
        <Title>{title}</Title>
        {lead && <Lead>{lead}</Lead>}
      </H3Wrapper>
    </ArticleTeaserRoot>
  )
}

const H3Wrapper = styled.h3`
  margin: 0;
  line-height: 0 !important;
`

const ArticleTeaserRoot = styled.a`
  //
  font-family: var(--font-plex);
  line-height: 1.15rem;
  //
  display: flex;
  flex-direction: row;
  justify-content: flex-start;

  align-items: center;
  //
  /* height: calc(100% - 20px); */
  color: #202346;
  flex: 1 1 auto;
  padding: 20px;
  line-height: 0;
  position: relative;
  background-color: var(--brandblue-bright-5);
  height: auto;
  /* height: 100%; */
  &:hover {
    cursor: pointer;
    opacity: 0.7;
    color: #202346;
  }
  * {
    pointer-events: none;
  }
`

const TitleHead = styled.span`
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 2rem;
  color: var(--tenant-color);
  margin-bottom: 5px;
  display: inline-block;
`
const Title = styled.span`
  display: block;
  font-family: var(--font-source);
  font-size: 2.2rem;
  font-weight: 600;
  line-height: 2.5rem;
  width: 100%;
`
const Lead = styled.p`
  font-family: var(--font-plex);
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 2.1rem;
`
